import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { LoginForm } from './LoginForm';
import { inject, observer } from 'mobx-react';
import {
    STORE_COMMON, STORE_AUTH
} from '../../constants';
import { AuthStore } from '../../stores';

interface ILoginProps {
    isAuthenticated: boolean;
}

interface ILoginPageState {
    username: string;
    password: string;
    rememberMe: boolean;
}

type LoginProps = ILoginProps
    // & typeof SessionStore.actionCreators
    & RouteComponentProps<{}>


@inject(STORE_COMMON, STORE_AUTH)
@observer
class LoginPageComponent extends React.Component<LoginProps, ILoginPageState> {
    constructor(props: any) {
        super(props);

        this.state = {
            username: "",
            password: "",
            rememberMe: false
        };


        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }



    private onSubmit() {
        const authStore = (this.props as any)[STORE_AUTH] as AuthStore;

        authStore.logIn(this.state.username, this.state.password, this.state.rememberMe);
    }

    private onChange(fieldName: string, value: string) {
        if (fieldName == "username")
            this.setState({
                username: value
            });
        else if (fieldName == "password")
            this.setState({
                password: value
            });
    }

    public render() {
        return <LoginForm
            username={this.state.username}
            password={this.state.password}
            rememberMe={this.state.rememberMe}
            onChange={this.onChange}
            onSubmit={this.onSubmit}
            onChangeCheckbox={(value: boolean) => {
                this.setState({
                    rememberMe: value
                });
            }}
        />;
    }
}

const LoginPage = withRouter(LoginPageComponent)
export default LoginPage;